import { cn as designCn } from '@progear/design';
import type { ClassValue } from 'clsx';

/**
 * App-level className helper (shadcn convention: `@/lib/utils`).
 * Delegates to the shared `cn` in @progear/design so the merge logic lives
 * in exactly one place (replit.md master rule: zero duplicated logic).
 */
export function cn(...inputs: ClassValue[]): string {
  return designCn(...inputs);
}
